module.exports = __webpack_public_path__ + "img/Bravia_BZ35L_Richer more natural colour.4e8e56e7.jpg";